import { Trans } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useState } from "react";
import { useFragment } from "react-relay";

import { useTrackEvent } from "@/utils/Analytics/Mixpanel/hooks/useTrackEvent";
import { CalendarIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  VStack,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { BookModal } from "../../../BookModal";
import { BookButton_session$key } from "./__generated__/BookButton_session.graphql";

type Props = {
  sessionRef: BookButton_session$key | null;
};

export const BookButton = ({ sessionRef }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const session = useFragment(BookButtonFragmentString, sessionRef);

  const trackEvent = useTrackEvent();

  return (
    <>
      <Pressable
        style={{ borderRadius: 16 }}
        px={{ base: 1, md: 4 }}
        pb={{ base: 3, md: 5 }}
        pt={{ base: 4, md: 5 }}
        backgroundColor="main-primary-500"
        alignItems="center"
        justifyContent="center"
        _hover={{
          backgroundColor: "main-primary-600",
        }}
        _pressed={{
          backgroundColor: "main-primary-700",
        }}
        height={{ base: 64, lg: 48 }}
        ml={{
          md: 2,
        }}
        minWidth={{ base: 64, lg: "auto" }}
        onPress={() => {
          trackEvent("Homepage.BookNowCTAClicked", {});
          setIsModalOpen(true);
        }}
      >
        <VStack
          alignItems="center"
          justifyContent="center"
          gap={1}
          flexDirection={{ base: "column", lg: "row" }}
        >
          <CalendarIcon color="icon-inverse" />
          <Text
            maxFontSizeMultiplier={2}
            marginLeft={{ base: 0, lg: 2 }}
            color="text-inverse"
            variant="mainTiny"
            mb={0}
          >
            <Trans>Book</Trans>
          </Text>
        </VStack>
      </Pressable>
      <BookModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        sessionRef={session ?? null}
      />
    </>
  );
};

const BookButtonFragmentString = graphql`
  fragment BookButton_session on Session {
    ...BookModal_session
  }
`;
